import { createAsyncThunk } from '@reduxjs/toolkit';

import SignInProcessApi from 'api/curo/SignInProcessApi';
import { SignInProcessActionTypes } from 'enums/curo/SignInProcessActionTypes';

export const createSendVerificationCodeThunk = (api: SignInProcessApi) =>
  createAsyncThunk(SignInProcessActionTypes.SendVerificationCode, async (phoneNumber: string) => {
    await api.sendVerificationCode(phoneNumber);
  });
